import AppStoreImage from '@/assets/app-store.webp';
import PlayStoreImage from '@/assets/play-store.webp';
import ISOComplianceLogo from '@/logos/iso-compliance.webp';
import SOCComplianceLogo from '@/logos/soc-compliance.webp';
import { NEEDL_PAGES } from '@/utils/needl-pages';

export const FOOTER_LINK_TYPES = {
  SECURITY: 'SECURITY',
  APP_STORE: 'APP_STORE',
} as const;

export const FOOTER_LINKS = {
  [FOOTER_LINK_TYPES.SECURITY]: [
    {
      src: SOCComplianceLogo,
      alt: 'SOCComplianceLogo',
      href: NEEDL_PAGES.SECURITY_DETAILS_PAGE,
      className: 'w-16',
    },
    {
      src: ISOComplianceLogo,
      alt: 'ISOComplianceLogo',
      href: NEEDL_PAGES.SECURITY_DETAILS_PAGE,
      className: 'w-16',
    },
  ],
  [FOOTER_LINK_TYPES.APP_STORE]: [
    {
      src: PlayStoreImage,
      alt: 'PlayStoreImage',
      href: NEEDL_PAGES.PLAY_STORE_URL,
      className: 'w-28',
    },
    {
      src: AppStoreImage,
      alt: 'AppStoreImage',
      href: NEEDL_PAGES.APP_STORE_URL,
      className: 'w-28',
    },
  ],
};

export type LinkType = keyof typeof FOOTER_LINKS;
